"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { Star } from "lucide-react";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

/** Renders 5 stars with full, half, or empty fill based on rating (0-5) */
function StarRating(t0) {
  const $ = _c(4);
  const {
    rating
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "#ffffff",
      opacity: 0.3,
      fill: "#facc15"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dimStyle = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "#ffffff",
      fill: "#facc15"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const fullStyle = t2;
  let t3;
  if ($[2] !== rating) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<Star key={i} className="w-3 h-3" style={fullStyle} />);
      } else {
        if (rating >= i - 0.5) {
          stars.push(<span key={i} className="relative w-3 h-3 inline-block"><Star className="w-3 h-3 absolute inset-0" style={dimStyle} /><span className="absolute inset-0 overflow-hidden" style={{
              width: "50%"
            }}><Star className="w-3 h-3" style={fullStyle} /></span></span>);
        } else {
          stars.push(<Star key={i} className="w-3 h-3" style={dimStyle} />);
        }
      }
    }
    t3 = <span className="flex items-center gap-0.5">{stars}</span>;
    $[2] = rating;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  genre?: FieldConfig;
  excerpt?: FieldConfig;
  imageSrc?: FieldConfig;
  criticsRating?: FieldConfig;
  userRating?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export const VerticalMediamRatingNews = t0 => {
  const $ = _c(50);
  const {
    title: t1,
    genre: t2,
    excerpt: t3,
    imageSrc: t4,
    criticsRating: t5,
    userRating: t6,
    slug,
    imageMetadata
  } = t0;
  let t7;
  if ($[0] !== t1) {
    t7 = t1 === undefined ? {
      hidden: false,
      value: "\u0B86\u0BA4\u0BBF\u0BAA\u0BC1\u0BB0\u0BC1\u0BB7\u0BCD \u0BA4\u0BBF\u0BB0\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F\u0BAE\u0BCD",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const title = t7;
  let t8;
  if ($[2] !== t2) {
    t8 = t2 === undefined ? {
      hidden: false,
      value: "\u0B86\u0B95\u0BCD\u0BB7\u0BA9\u0BCD, \u0B83\u0BAA\u0BC7\u0BA3\u0BCD\u0B9F\u0BB8\u0BBF, \u0B9F\u0BBF\u0BB0\u0BBE\u0BAE\u0BBE",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const genre = t8;
  let t9;
  if ($[4] !== t3) {
    t9 = t3 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BBF\u0BB0\u0BC1\u0BA4\u0BBF \u0B9A\u0BA9\u0BCB\u0BA9\u0BCD \u0B9C\u0BBE\u0BA9\u0B95\u0BBF ; \u0BAA\u0BBF\u0BB0\u0BAA\u0BBE\u0BB8\u0BCD -\u0BB0\u0BBE\u0B95\u0BB5\u0BCD; \u0BA4\u0BC7\u0BB5\u0BC1\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBE \u0BA8\u0BBE\u0B95\u0BC7 \u0BAA\u0B9C\u0BCD\u0BB0\u0B99\u0BCD ; \u0B9A\u0BC8\u0B83\u0BAA\u0BCD \u0B85\u0BB2\u0BBF \u0B95\u0BBE\u0BA9\u0BCD \u0BB2\u0B99\u0BCD\u0B95\u0BC7\u0BB7\u0BCD; \u0B9A...",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const excerpt = t9;
  let t10;
  if ($[6] !== t4) {
    t10 = t4 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const imageSrc = t10;
  const criticsRating = t5 === undefined ? {
    hidden: false,
    value: "3.5",
    customClass: ""
  } : t5;
  let t11;
  if ($[8] !== t6) {
    t11 = t6 === undefined ? {
      hidden: false,
      value: "1.5",
      customClass: ""
    } : t6;
    $[8] = t6;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const userRating = t11;
  const titleValue = title?.value || "";
  const genreValue = genre?.value || "";
  const excerptValue = excerpt?.value || "";
  let t12;
  if ($[10] !== imageSrc?.value) {
    t12 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const imageSrcValue = t12;
  criticsRating?.value || "";
  const userRatingValue = userRating?.value || "";
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      minHeight: "405px"
    };
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== imageMetadata || $[14] !== imageSrc?.customClass || $[15] !== imageSrc?.hidden || $[16] !== imageSrcValue || $[17] !== titleValue) {
    t14 = !imageSrc?.hidden && <div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[13] = imageMetadata;
    $[14] = imageSrc?.customClass;
    $[15] = imageSrc?.hidden;
    $[16] = imageSrcValue;
    $[17] = titleValue;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== title?.customClass || $[20] !== title?.hidden || $[21] !== titleValue) {
    t15 = !title?.hidden && <h3 className={`text-16-tamil-600 text-FFDB59 ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[19] = title?.customClass;
    $[20] = title?.hidden;
    $[21] = titleValue;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== genre?.customClass || $[24] !== genre?.hidden || $[25] !== genreValue) {
    t16 = !genre?.hidden && <p className={`text-12-tamil-500 text-FFFFFF line-clamp-1 ${genre?.customClass || ""}`}>{genreValue}</p>;
    $[23] = genre?.customClass;
    $[24] = genre?.hidden;
    $[25] = genreValue;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== excerpt?.customClass || $[28] !== excerpt?.hidden || $[29] !== excerptValue) {
    t17 = !excerpt?.hidden && <p className={`text-14-tamil-400 text-FFFFFF leading-[1.4] line-clamp-3 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[27] = excerpt?.customClass;
    $[28] = excerpt?.hidden;
    $[29] = excerptValue;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t15 || $[32] !== t16 || $[33] !== t17) {
    t18 = <div className="flex flex-col gap-2">{t15}{t16}{t17}</div>;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t14 || $[36] !== t18) {
    t19 = <div className="p-4 gap-4 flex flex-col" style={t13}>{t14}{t18}</div>;
    $[35] = t14;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== userRating?.customClass || $[39] !== userRating?.hidden || $[40] !== userRatingValue) {
    t20 = !userRating?.hidden && <div className={`flex items-center justify-end ${userRating?.customClass || ""}`}><span className="text-12-english-500 text-FFFFFF mr-3">Users Ratings</span><StarRating rating={parseFloat(userRatingValue) || 0} /><span className="text-FFDB59 text-12-english-400 ml-3">{userRatingValue}/5</span></div>;
    $[38] = userRating?.customClass;
    $[39] = userRating?.hidden;
    $[40] = userRatingValue;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t20) {
    t21 = <div className="border-t border-2D497E p-4"><div className="flex gap-4"><div className="flex-1 gap-4">{t20}</div></div></div>;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t19 || $[45] !== t21) {
    t22 = <div className="flex flex-col overflow-hidden bg-012061">{t19}{t21}</div>;
    $[44] = t19;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  const content = t22;
  if (slug) {
    const t23 = `/${slug}`;
    let t24;
    if ($[47] !== content || $[48] !== t23) {
      t24 = <Link href={t23} className="block hover:opacity-90 transition-opacity cursor-pointer">{content}</Link>;
      $[47] = content;
      $[48] = t23;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    return t24;
  }
  return content;
};